export default __webpack_public_path__ + "static/media/children.5fca59e4.jpg";